import { queryKeys } from "../queryKeys";
import { useQuery } from "@tanstack/react-query";
import { CandidateWage } from "../models/CandidateWage";
import { axiosInstance, validateUuid } from "../../utils";

export function useCandidateWages(clientId: string | undefined, entityId: string | undefined, candidateId: string | undefined) {
    const axios = axiosInstance();

    return useQuery({
        ...queryKeys.candidateWage.byCandidateId(candidateId),
        queryFn: () => {
            if (candidateId) {
                return axios
                    .get<CandidateWage[]>(
                        `api/clients/${validateUuid(clientId)}/entities/${validateUuid(entityId)}/candidates/${validateUuid(candidateId)}/wages`
                    )
                    .then(response => response.data);
            } else {
                return [] as CandidateWage[];
            }
        },
        enabled: !!candidateId,
    });
}
